import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'

import '../../asset/less/component.css'

import {Typography} from 'antd'
import GalleryTablePanel from "../../component/GalleryTablePanel";
import {ClockCircleOutlined, SortAscendingOutlined, SortDescendingOutlined} from "@ant-design/icons";
import {getAllArtistContracts} from '../../api/artistContracts'
import {getAllArtistNames} from '../../api/artistNames'
import HttpError from '../../component/base/HttpError'
import {URL_NEW_AGREEMENTS, URL_SIGN_AGREEMENTS} from '../../const'
import {SINGLE_SELECT_TYPE_TAG} from '../../component/base/filters/FilterUtils'
import samplePicture from '../../asset/image/document.svg'
import {getEditUrl} from '../../component/Utils'
import {is_admin_user} from "../../app/role";

const {Title} = Typography

@connect((state) => ({
    //decorator, gives component access to the state
    userId: state.user.info.id,
    email: state.user.info.email,
    role: state.user.info.role
}))

// API to submit (create) document by admin only: https://revart.co/api/v1/artist-contracts/
// 403 forbiddent for normal user.
// Documents are prepared for Signer to sign. So, documents (agreements) have Signer, Date Signed (If Signed).
class AgreementNew extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            contracts: []
        }
        this.columnsInfo = [
            {
                title: '#',
                dataIndex: 'id',
                key: 'id',
                width: 45
            },
            {
                title: 'Document Title',
                dataIndex: 'title',
                key: 'title',
                width: 80
            },
            {
                title: 'Signers', // No real field
                dataIndex: 'name', // Derive value from is_signed
                key: 'name',
                width: 80
            },
            {
                title: 'Signed', // No real field
                dataIndex: 'is_signed', // Derive value from is_signed
                key: 'is_signed',
                width: 50,
                render: (text, record, index) => {
                    return (record.is_signed ? 'true' : 'false')
                }
            },
            {
                title: 'Signed by RevArt', // No real field
                dataIndex: 'is_signed_revart', // Derive value from is_signed
                key: 'is_signed_revart',
                width: 80,
                render: (text, record, index) => {
                    return (record.is_signed_revart ? 'true' : 'false')
                }
            },
            {
                title: 'Date Added',
                dataIndex: 'create',
                key: 'create',
                width: 65
            },
            {
                title: 'Date Signed',
                dataIndex: 'update',
                key: 'update',
                width: 65,
                render: (text, record, index) => {
                    return (record.update ? text.split('T')[0] : '')
                }
            },
        ]
        this.sortOptions = [
            {
                text: 'Document Title (a-z)',
                value: 'title',
                icon: <SortDescendingOutlined/>
            },
            {
                text: 'Document Title (z-a)',
                value: '-title',
                icon: <SortAscendingOutlined/>
            },
            {
                text: 'Date Added (recent)',
                value: '-create',
                icon: <ClockCircleOutlined/>
            },
            {
                text: 'Date Added (old)',
                value: 'create',
                icon: <ClockCircleOutlined/>
            },
            {
                text: 'Date Signed (recent)',
                value: '-update',
                icon: <ClockCircleOutlined/>
            },
            {
                text: 'Date Signed (old)',
                value: 'update',
                icon: <ClockCircleOutlined/>
            },
        ]
        this.filterOptions = [
            {
                type: SINGLE_SELECT_TYPE_TAG,
                key: 'Signers_Type',
                modalTitle: 'Signers Selection',
                selections: []
            }
        ]
        if (is_admin_user(this.props)) {
            this.filterOptions[0]['selections'].push({
                filterField: 'isSignedFilter',
                filterLabel: 'Signed by Artist', // filter for is_signed field
                selectoptions: [{'key': 'true', 'label': 'Signed by Artist'}, {
                    'key': 'false',
                    'label': 'Not Signed by Artist'
                }]
            });
            this.filterOptions[0]['selections'].push({
                filterField: 'isDeclinedFilter',
                filterLabel: 'Declined by Artist',
                selectoptions: [{'key': 'true', 'label': 'Declined by Artist'}, {
                    'key': 'false',
                    'label': 'Not Declined by Artist'
                }]
            });
        } else {
            this.filterOptions[0]['selections'].push({
                filterField: 'isSignedRevArtFilter',
                filterLabel: 'Signed by RevArt',
                selectoptions: [{'key': 'true', 'label': 'Signed by RevArt'}, {
                    'key': 'false',
                    'label': 'Not Signed by RevArt'
                }]
            });
            this.filterOptions[0]['selections'].push({
                filterField: 'isDeclinedRevArtFilter',
                filterLabel: 'Declined by RevArt',
                selectoptions: [{'key': 'true', 'label': 'Declined by RevArt'}, {
                    'key': 'false',
                    'label': 'Not Declined by RevArt'
                }]
            });
        }
    }

    componentDidMount() {
        // console.log('componentDidMount called')
    }

    getInitialData = (resolve, reject, pageId, pageSize, sort, filters, search, cancelToken) => {
        getAllArtistNames().then((res) => {
            let artists = res.data
            let params = {}
            if (sort) {
                params['ordering'] = sort.value || sort
            }
            if (search) {
                params['search'] = search
            }
            if (filters.isSignedFilter) {
                params['isSignedFilter'] = filters.isSignedFilter.value
            }
            if (filters.isSignedRevArtFilter) {
                params['isSignedRevArtFilter'] = filters.isSignedRevArtFilter.value
            }
            if (filters.isDeclinedFilter) {
                params['isDeclinedFilter'] = filters.isDeclinedFilter.value
            }
            if (filters.isDeclinedRevArtFilter) {
                params['isDeclinedRevArtFilter'] = filters.isDeclinedRevArtFilter.value
            }
            getAllArtistContracts(params, pageId, pageSize, cancelToken).then((response) => {
                for (const contract of response.data.results) {
                    let name = ''
                    let artist = {}
                    if (contract.is_signed_revart) {
                        name = 'Revart, '
                    }
                    if (contract.is_signed) {
                        if (artists) {
                            artist = artists.filter((a) => {
                                return parseInt(a.artist_id) === contract.artist
                            })
                            if (artist[0]) {
                                name += this.capitalizeName(artist[0].name)
                            }
                        }
                    }
                    if (is_admin_user(this.props) && artists && !(contract.is_signed_revart || contract.is_signed)) {
                        artist = artists.filter((a) => {
                            return parseInt(a.artist_id) == contract.artist
                        })
                        if (artist[0]) {
                            name = '(' + this.capitalizeName(artist[0].name) + ')'
                        }
                    }
                    contract.name = name
                    if (is_admin_user(this.props)) {
                        contract.title = contract.title + ' ' + contract.name
                    }
                    contract.static_url = samplePicture;
                }
                const apiData = {
                    data: response.data
                }
                this.setState({contracts: response.data.results})
                resolve(apiData);
            }).catch((error) => {
                HttpError(error)
            })

        }).catch((error) => {
            HttpError(error)
        })
    }

    componentWillUnmount() {
        // console.log('componentWillUnmount called')
    }

    capitalizeName(name) {
        return name.replace(/\b(\w)/g, (s) => s.toUpperCase())
    }

    reqData = (pageId, pageSize, sort, filters, search) => {
        return new Promise((resolve, reject) => {
            this.getInitialData(resolve, reject, pageId, pageSize, sort, filters, search);
        });
    }

    deleteData = (id) => {
        // call api to delete by id
        return new Promise((resolve, reject) => {
            resolve();
        });
    }

    getOpenUrl = (record) => {
        let contractRecord;
        this.state.contracts?.forEach((contract) => {
            if (contract.id === record.id) {
                contractRecord = contract
            }
        })
        if (contractRecord) {
            const signing_url_split = contractRecord.sign_url.split('/')
            var sign_url = signing_url_split[4]
            if (is_admin_user(this.props) && contractRecord.revart_sign_url) {
                const revart_signing_url_split = contractRecord.revart_sign_url.split('/')
                sign_url = revart_signing_url_split[4]
            }
            return 'https://revartllc.eversign.com/document/' + sign_url + '/status'
        }
    }

    getDetailsUrl = (record) => {
        return getEditUrl(URL_SIGN_AGREEMENTS, record.id)
    }

    render() {
        return (
            <div>
                <GalleryTablePanel
                    name={'agreement'}
                    requestData={this.reqData}
                    columns={this.columnsInfo}
                    tableWidth={1000}
                    actionWidth={50}
                    getOpenUrl={this.getOpenUrl}
                    sortOptions={this.sortOptions}
                    defaultSortOption={this.sortOptions[0]}
                    filterOptions={this.filterOptions}
                    addNewUrl={URL_NEW_AGREEMENTS}
                    getDetailsUrl={this.getDetailsUrl}
                    disableAdd={!is_admin_user(this.props)}
                    viewOptions={['gallery', 'table']}/>
            </div>
        )
    }

}

export default withRouter(AgreementNew)